<template>
  <v-container fluid>
    <br>
    <br>
    <v-layout>
      <v-flex class=margin-custom-width-left>
        <v-flex xs12 sm10 md6>
        <v-form ref="form" v-model="validCredentials">
          <label class=headline>Login</label>
          <v-text-field
            v-model="loginId"
            prepend-icon="person"
            :rules="loginRules"
            name="login"
            label="Email or Phone number"
            type="text"
          ></v-text-field>
          <v-text-field
            v-model="password"
            id="password"
            hint="Use secret key sent to you. Secret key is case sensitive. If you are new user, create an account so you can get key to sign-in."
            prepend-icon="lock"
            :rules="passwordRules"
            name="password"
            label="Secret Key"
            type="text"
          ></v-text-field>
          <v-spacer></v-spacer>
          <br>Forgot key?
          <router-link to="/RequestKey" style="text-decoration: none;">&nbsp;Request new one</router-link>
          <br>
          <br>
          <v-btn :disabled="!validCredentials" @click="login" color="primary">Login</v-btn> Or
          <v-btn @click="newUser" color="info" outline>Create an account</v-btn>
        </v-form>
        </v-flex>
      </v-flex>
    </v-layout>
  </v-container>
</template>


<script>
import { mapGetters, mapActions } from "vuex";
import moment from "moment";

export default {
  data: () => ({
    validCredentials: false,
    password: null,
    passwordRules: [v => !!v || "Secret Key is required"],
    loginId: "",
    loginRules: [
      v => !!v || "E-mail or a Phone number is required",
    ]
  }),

  methods: {
    moment,
    login() {
      let user = {
        userName: this.loginId,
        password: this.password
      };
      this.loginUser(user).then(() => {
        if (this.isLoggedIn) {
          this.user.lastLogIn = moment()
            .utc()
            .format("YYYY-MM-DD HH:mm:ss");
          this.updateAccount(this.user);
          if (this.$route.query.redirect) {
            this.$router.push({ path: this.$route.query.redirect });
          } else {
            this.$router.push({ path: "/schedule" });
          }
        }
      });
    },

    newUser() {
      this.$router.push({ path: "/newUser" });
    },
    ...mapActions("auth", ["loginUser"]),
    ...mapActions("account", { updateAccount: "update" })
  },
  computed: {
    ...mapGetters("auth", ["isLoggedIn", "user"])
  }
};
</script>